export class StatementOfBenefitsService {

    constructor($resource, ApiService, Upload, $cookies, DateService, Constants) {
        'ngInject';

        this.$resource = $resource;
        this.apiService = ApiService;

        const disclaimerResourceUrl = this.apiService.getResourceUrl('/statement-of-benefits');

        this.disclaimerResource = this.$resource(disclaimerResourceUrl, null, {
            update: {
                method: 'PUT',
            },
        });
    }

    getDisclaimerInfo() {
        const promise = this.disclaimerResource.get().$promise;
        return promise
            .then(details => {
                if (details) {
                    return this._getDisclaimerObject(details.details.statementOfBenefitDetails);
                }
                return null;
            })
            .catch((error) => {
                throw this.apiService.getErrorMessage(error);
            });
    }

    _getDisclaimerObject(details) {
        if (details === null) {
            return {
                id: "",
                desc: ""
            }
        } else {
            return {
                id: details.statementOfBenefitsId,
                desc: details.plainText,
                plainDescription: details.value
            };
        }

    }

    updateDisclaimerInfo(disclaimerDetails) {
        const promise = this.disclaimerResource.save(disclaimerDetails).$promise;
        return promise
            .then((details) => {
                return details.data
            })
            .catch((error) => {
                throw error.data;
            })
    }

}



// WEBPACK FOOTER //
// ./src/app/components/statement-of-benefits/statement-of-benefits.service.js